import Vue from 'vue'
import defaultState from './state'

export default {
  init(state) {
    const oldServiceList =
      state.serviceList /* 初始化modal，暫存serviceList的state */
    Object.assign(state, defaultState)
    Vue.set(
      state,
      'serviceList',
      oldServiceList,
    ) /* 將oldServiceList放回store中 */
  },
  setServiceList(state, serviceList) {
    Vue.set(state, 'serviceList', serviceList)
  },
  setId(state, id) {
    Vue.set(state, 'id', id)
  },
  setModal(
    state,
    {
      billInfo,
      managerInfo,
      serviceInfo,
      passengerInfo,
      driverInfo,
      driverState,
    },
  ) {
    // 如果是普通預約單（reservationType !== 2），清除機場預約單專屬欄位
    if (billInfo && billInfo.reservationType !== 2) {
      const airportOnlyFields = [
        'passengerCount',
        'paymentMethod',
        'needInvoice',
        'taxId',
        'invoiceTitle',
        'invoiceAddress',
      ]
      airportOnlyFields.forEach((key) => {
        if (billInfo[key] !== undefined) {
          delete billInfo[key]
        }
      })
    }
    Vue.set(state, 'billInfo', billInfo)
    Vue.set(state, 'managerInfo', managerInfo)
    Vue.set(state, 'serviceInfo', serviceInfo)
    Vue.set(state, 'passengerInfo', passengerInfo)
    Vue.set(state, 'driverInfo', driverInfo)
    Vue.set(state, 'driverState', driverState)
  },
  mergeBillInfoFromList(state, { billInfo = {}, driverInfo = {} } = {}) {
    // 只在機場預約單（reservationType === 2）時才合併這些欄位
    if (state.billInfo.reservationType !== 2) {
      return
    }
    const billFields = [
      'passengerCount',
      'seatNumber',
      'paymentMethod',
      'amount',
      'needInvoice',
      'taxId',
      'invoiceTitle',
      'invoiceAddress',
      'passengerCancel',
      'driverCancel',
    ]
    billFields.forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(billInfo, key)) {
        Vue.set(state.billInfo, key, billInfo[key])
      }
    })

    const driverFields = ['callNumber', 'licence', 'carBrand', 'phone']
    driverFields.forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(driverInfo, key)) {
        Vue.set(state.driverInfo, key, driverInfo[key])
      }
    })
  },
  setOpenAt(state, openAt) {
    Vue.set(state, 'openAt', openAt)
  },
}



// WEBPACK FOOTER //
// ./src/store/reserveModal/mutations.js